import { Page } from 'components'
import { Content } from './styles'
import { Gallery } from './components/Gallery'
import { Dashboard } from './components/Dashboard'
import { Links } from './components/Links'
import { GoalProgress } from './components/GoalProgress'
import { usePermissions } from 'commons/customHooks'
import { SCREENS } from 'commons/utils/permissions'

function Home() {
  const { verifyPermission } = usePermissions()

  return (
    <Page>
      <Content>
        <Gallery />
        <Dashboard />
        {verifyPermission(SCREENS.RANKING) && <GoalProgress />}
        <Links />
      </Content>
    </Page>
  )
}

export default Home
